<template>
  <div :id="app.name" class="cards-main">
    <v-card width="350" class="mx-auto cards" @click="logApp()" color="#1e1e1e">
      <div
        :style="'border-left: 7px solid ' + (app.color ? app.color : '#1e1e1e')"
        class="cards-content"
      >
        <v-avatar size="100">
          <img
            v-if="app.app_photo && app.app_photo.url"
            class="cards-content-logo"
            :src="app.app_photo.url"
          />
          <img
            v-else
            class="cards-content-logo"
            src="https://s3-sa-east-1.amazonaws.com/gorillascode-auth/apps/2.png"
          />
        </v-avatar>
        <div class="cards-content-app-info">
          <p class="cards-content-app-info-title mb-0">
            {{ app.name }}
          </p>
          <p class="cards-content-app-info-text mb-0">{{ app.description }}</p>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { accessAppLog } from "@/services/logs";

@Component
export default class Cards extends Vue {
  @Prop() readonly app: any;

  logApp(): void {
    accessAppLog(this.app.id).then(() =>
      window.open(this.app.login_url, "_blank"),
    );
  }

}
</script>
<style lang="scss" scoped>
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}

.v-card__subtitle,
.v-card__text {
  line-height: 0;
}

.cards-main {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-evenly;

  @media (min-width: 767px) {
    padding: 30px 30px 0 30px;
  }

  @media (max-width: 767px) {
    width: 100%;
  }

  .cards {
    margin-top: 40px;
    margin-left: 0 !important;
    margin-right: 0 !important;
    opacity: 0.8;
    transition: opacity 0.25s ease-in-out;
    -moz-transition: opacity 0.25s ease-in-out;
    -webkit-transition: opacity 0.25s ease-in-out;

    &:hover {
      zoom: 1;
      filter: alpha(opacity=50);
      opacity: 1.4;
    }

    p {
      color: #ffffff !important;
    }

    &-content {
      display: flex;
      align-items: stretch;
      padding: 20px;
      height: 154px;
      &-app-info {
        display: flex;
        flex-direction: column;
        padding-left: 16px;
        justify-content: space-between;
        height: 100%;
        flex: 1;

        &-title {
          font-size: 1.25rem;
          font-weight: 600;
        }

        &-text {
          font-size: 0.875rem;
          font-weight: 600;
        }
      }
      p,
      .cards-content-app-info-subtitle,
      .cards-content-app-info-title {
        color: #ffffff;
        flex-wrap: wrap;
      }
    }
  }
}
</style>
